module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAArCAYAAABSFVnaAAAAGUlEQVQYV2Ocvu3yfwYGBgYmBigYZdCZAQDyJQN1Of+EpwAAAABJRU5ErkJggg=="